// TODO: remove this dependency
import { stringify, parse } from 'qs';

export function urlQuery(parameters, includeOldParameters = false) {
    const oldParameters = includeOldParameters ? parse(window.location.search, { ignoreQueryPrefix: true }) : {};
    const data = {
        ...oldParameters,
        ...parameters,
    };
    return stringify(data, { arrayFormat: 'comma' });
}

export function urlQueryFromParameters(parameters, includeOldParameters = false) {
    const urlSearchParams = new URLSearchParams(includeOldParameters ? globalThis.location.search : '');

    for (const [key, value] of Object.entries(parameters)) {
        if (value !== undefined) {
            urlSearchParams.set(key, value);
        }
        if (value === undefined) {
            urlSearchParams.delete(key);
        }
    }

    return urlSearchParams.toString();
}
